export default {
  "title": "System Dashboard",
  "subtitle": "Real-time telemetry and system health monitoring",
  "viewLogs": "View logs",
  "updates": "Updates",
  "refreshing": "Refreshing",
  "refresh": "Refresh",
  "copied": "Copied!",
  "failed": "Failed",
  "copyDiagnostics": "Copy diagnostics",
  "monday": "Monday",
  "load": "Load {{values}}",
  "bandwidthPeriods": "Today · Week-to-date · Month-to-date · Rolling 30 days (week starts {{day}})",
  "vnstatDelayed": "vnStat delayed: {{error}}",
  "noData": "No data",
  "bandwidthTotals": "Bandwidth totals",
  "retryVnstat": "Retry vnStat",
  "retry": "Retry",
  "selectInterfaceHelp": "Select a network interface in General Settings to enable bandwidth tracking.",
  "openSettings": "Open settings",
  "todayTitle": "Today",
  "weekToDate": "Week-to-date",
  "monthToDate": "Month-to-date",
  "last30Days": "Last 30 Days",
  "rollingWindow": "Rolling window",
  "cpu": "CPU",
  "memory": "Memory",
  "ramUsage": "RAM usage",
  "disk": "Disk",
  "swap": "Swap",
  "swapUsage": "Swap usage",
  "today": "Today",
  "bandwidth": "Bandwidth",
  "thisMonth": "This month",
  "viewBandwidthTooltip": "View Bandwidth Total Stats",
  "viewBandwidth": "View bandwidth total stats",
  "cpuRules_one": "Triggered {{count}} CPU rule",
  "cpuRules_other": "Triggered {{count}} CPU rules",
  "cpuDiagnosticsValues": "CPU: {{cpu}}% | Load: {{load}}",
  "serverReturned": "Server returned {{status}}",
  "cpuRunning": "CPU diagnostics running",
  "optimizeCpu": "Optimize CPU",
  "diagnosing": "Diagnosing...",
  "optimize": "Optimize",
  "memoryRunning": "Memory optimization running",
  "optimizeMemory": "Optimize memory",
  "optimizing": "Optimizing...",
  "cpuCollected": "CPU diagnostics collected",
  "memoryOptimized": "Memory optimized",
  "memoryOptimizedDetail": "Page cache, dentries, and inodes cleared successfully.",
  "cleanupFailed": "Memory cleanup failed",
  "networkError": "Network error",
  "model": "Model",
  "topology": "Topology",
  "frequency": "Freq",
  "temperature": "Temp",
  "ioWait": "IO Wait",
  "total": "Total",
  "cached": "Cached",
  "none": "None",
  "available": "Available",
  "showSeries": "Show {{series}}",
  "hideSeries": "Hide {{series}}",
  "swapUsed": "Swap used",
  "swapFree": "Swap free",
  "swapSummary": "Used {{used}} / {{total}}",
  "swapDevice": "{{path}} (prio {{priority}})",
  "memoryUsedOf": "Used {{percent}} of {{total}}",
  "memoryError": "Could not load memory telemetry.",
  "memorySeries": "Memory series",
  "swapSummaryTitle": "Swap summary",
  "memorySwap": "Memory & Swap",
  "memoryDescription": "Memory usage + swap activity",
  "legend": "Legend",
  "memoryEmpty": "No memory telemetry available yet",
  "emptyDescription": "Data will appear once the sampler collects metrics",
  "memoryChart": "Memory usage chart showing used, cached, buffers, and free memory over time",
  "swapChart": "Swap usage chart showing swap used and swap free over time",
  "noSwap": "No swap configured",
  "used": "Used",
  "buffers": "Buffers",
  "free": "Free",
  "lastUpdated": "Last updated {{time}}",
  "lastSampled": "Last sampled {{time}}",
  "liveUpdated": "Live updated {{time}}",
  "snapshotUpdated": "Snapshot updated {{time}}",
  "networkHistoryUpdated": "Network history updated {{time}}",
  "cpuHistoryUpdated": "CPU history updated {{time}}",
  "memoryHistoryUpdated": "Memory history updated {{time}}",
  "vnstatUpdated": "vnStat updated {{time}}",
  "historyUnavailable": "History unavailable. {{error}}",
  "advanced": "Advanced",
  "networkInterface": "Network Interface",
  "networkInterfaceHelp": "Select which interface to monitor for throughput data.",
  "advancedInterfaces": "Show advanced interfaces",
  "advancedInterfacesHelp": "Include loopback, bridge, and VPN tunnel adapters.",
  "redisConnection": "Redis Connection",
  "redisHelp": "Used for live throughput history (scroll/zoom). URL overrides host/port.",
  "configureRedis": "Configure Redis",
  "redisUrl": "Redis URL",
  "host": "Host",
  "port": "Port",
  "password": "Password",
  "historyHelp": "Shows daily bandwidth totals from vnStat.",
  "dataDelayed": "Data delayed… reconnecting",
  "retryFeed": "Retry live feed",
  "retryHistory": "Retry history",
  "generalSettings": "Open General Settings",
  "exportChart": "Export chart data",
  "advancedOptions": "Advanced options",
  "optional": "Optional",
  "exportHistory": "Export history data",
  "streamingMaintenance": "Streaming Maintenance",
  "live": "Live",
  "connecting": "Connecting",
  "collecting": "Collecting live telemetry…",
  "unavailableTelemetry": "Telemetry unavailable",
  "saving": "Saving…",
  "save": "Save",
  "testing": "Testing…",
  "testConnection": "Test connection",
  "hideHistory": "Hide 30-day history",
  "viewHistory": "View 30-day history",
  "configureHistory": "Configure a network interface to view bandwidth history.",
  "noHistory": "Bandwidth history not available yet.",
  "loading": "Loading",
  "unavailable": "Unavailable",
  "unknown": "Unknown",
  "stale": "Stale",
  "autoSelect": "Auto select",
  "cpuRules_many": "Triggered {{count}} CPU rules",
  "notConfigured": "Not configured",
  "healthy": "Healthy",
  "needsReview": "Needs review",
  "connected": "Connected",
  "redisFailed": "Redis connection failed",
  "redisSaveFailed": "Failed to save Redis settings",
  "redisSaved": "Redis settings saved",
  "redisSavedDetail": "Live history will use Redis once connected.",
  "redisConnected": "Redis connected",
  "interfaceUnavailable": "{{name}} (unavailable)",
  "appRouting": "{{app}} routing",
  "interfaceUp": "up",
  "interfaceDown": "down",
  "interfaceDetails": "{{name}} ({{details}})",
  "interfaceUpdateFailed": "Failed to update interface",
  "interfaceUpdated": "Interface updated",
  "interfaceUpdatedDetail": "Network metrics now follow the selected interface.",
  "interfaceVisibilityFailed": "Failed to update interface visibility",
  "cpuOptimizeFailed": "CPU optimization failed"
} as const;
